module.exports = __webpack_public_path__ + "static/media/legalInfoIcon.537783b5.svg";